import { render, staticRenderFns } from "./marketing_banner.vue?vue&type=template&id=fff5d786&"
import script from "./marketing_banner.vue?vue&type=script&lang=js&"
export * from "./marketing_banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports